var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-pink-add-button",class:{
    underline: _vm.underlined,
  },attrs:{"type":"button"},on:{"click":_vm.handleBtnClick}},[(!_vm.removePlus)?_c('img',{attrs:{"src":require("../../icons/dod/dodAddPlusIcon.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }